import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import values from 'lodash.values';
import Dialog from 'material-ui/Dialog';
import { CSSTransitionGroup } from 'react-transition-group';
import Button from '../Button';
import Spinner from '../Spinner';
import './index.css';

export const SIZES = {
  XX_SMALL: 'xx-small',
  X_SMALL: 'x-small',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  X_LARGE: 'x-large',
  XX_LARGE: 'xx-large',
};

const propTypes = {
  confirmButtonText: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  onConfirm: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  cancelButtonText: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  onHide: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element, PropTypes.string]).isRequired,
  disableConfirmBtn: PropTypes.bool,
  hideOnConfirm: PropTypes.bool,
  isLoading: PropTypes.bool,
  size: PropTypes.oneOf([...values(SIZES), 'default']),
  onCancel: PropTypes.func,
};

const defaultProps = {
  size: SIZES.MEDIUM,
  title: null,
  cancelButtonText: null,
  onHide: null,
  onConfirm: null,
  disableConfirmBtn: false,
  hideOnConfirm: true,
  isLoading: false,
  onCancel: null,
};

/**
 * FIXME: This Modal component has its own state to handle open/close. If wrapper component wants to
 * close/hide it, has to be done using refs (poor design). Should be either refactored/deprecated at
 * some point, though still being used across many parts of the app.
 */
class Modal extends Component {
  state = {
    open: false,
  };

  show = () => {
    this.setState({
      open: true,
    });
  };

  hide = () => {
    const { onHide } = this.props;

    if (onHide) {
      onHide();
    }

    this.setState({
      open: false,
    });
  };

  confirm = () => {
    const { onConfirm, hideOnConfirm } = this.props;

    if (onConfirm) {
      onConfirm();
    }

    if (hideOnConfirm) {
      this.hide();
    }
  };

  cancel = () => {
    const { onCancel } = this.props;

    if (onCancel) {
      onCancel();
    }

    this.hide();
  };

  renderActions = () => {
    const { disableConfirmBtn, cancelButtonText, confirmButtonText } = this.props;

    const ConfirmButton = (
      <span className="Modal__btn">
        <Button disabled={disableConfirmBtn} onClick={this.confirm}>
          <strong>{confirmButtonText}</strong>
        </Button>
      </span>
    );

    if (cancelButtonText) {
      const CancelButton = (
        <span className="Modal__btn">
          <Button variant="secondary" onClick={this.cancel}>
            <strong>{cancelButtonText}</strong>
          </Button>
        </span>
      );

      return [CancelButton, ConfirmButton];
    }

    return [ConfirmButton];
  };

  render() {
    const { title, children, isLoading, size } = this.props;
    const contentClassName = classNames('Modal__content', {
      'Modal__content--xxSmall': size === SIZES.XX_SMALL,
      'Modal__content--xSmall': size === SIZES.X_SMALL,
      'Modal__content--small': size === SIZES.SMALL,
      'Modal__content--medium': size === SIZES.MEDIUM,
      'Modal__content--large': size === SIZES.LARGE,
      'Modal__content--xLarge': size === SIZES.X_LARGE,
      'Modal__content--xxLarge': size === SIZES.XX_LARGE,
    });

    return (
      <Dialog
        open={this.state.open}
        onRequestClose={this.hide}
        title={title}
        actions={this.renderActions()}
        titleClassName="Modal__header"
        bodyClassName="Modal__body"
        actionsContainerClassName="Modal__footer"
        paperClassName="Modal__paper"
        contentClassName={contentClassName}
      >
        {children}

        <CSSTransitionGroup
          transitionName="CSSTG-fade"
          transitionEnterTimeout={375}
          transitionLeaveTimeout={300}
        >
          {isLoading && (
            <div className="Modal__loading_overlay">
              <Spinner />
            </div>
          )}
        </CSSTransitionGroup>
      </Dialog>
    );
  }
}

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;

export default Modal;



// WEBPACK FOOTER //
// ../ui-components/components/Modal/index.jsx